/**
 * Chart registry — the runtime catalog of chart types.
 *
 * Charts register themselves via side-effect import (see `charts/index.ts`).
 * `ChartRenderer` resolves a definition by type instead of branching on it.
 */

import type { ChartTypeDefinition } from './types';

const registry = new Map<string, ChartTypeDefinition>();

/** Register a chart type. Throws on duplicate id to surface accidental clobbering. */
export function registerChart(definition: ChartTypeDefinition): void {
  if (registry.has(definition.id)) {
    throw new Error(`Chart type already registered: ${definition.id}`);
  }
  registry.set(definition.id, definition);
}

/** Resolve a chart definition by type, or undefined if unregistered. */
export function getChart(id: string): ChartTypeDefinition | undefined {
  return registry.get(id);
}

/** All registered definitions, in registration order. For the editor's catalog. */
export function listCharts(): ChartTypeDefinition[] {
  return Array.from(registry.values());
}

/** Test-only: clear the registry. Not exported from the package barrel. */
export function __resetRegistry(): void {
  registry.clear();
}
